import Mutations from '../../odata/mutations';

export default { ...new Mutations('fringesItem'), ...new Mutations('fringesItems') };
